











import {Component, Vue, Prop} from "vue-property-decorator";
import Product from "@/api/Product";
import CompareModalBodyProduct from "@/components/Compare/CompareModal/CompareModalBodyProduct.vue";

@Component({
  components: {CompareModalBodyProduct}
})
export default class CompareModalBody extends Vue {
  @Prop() private products!: Product[];
  @Prop({default: []}) private currentProductIds!: number[];

  selectProduct(productId: number) {
    if (!this.isProductInCurrent(productId)) {
      this.$emit("product-selected", productId)
    }
  }

  isProductInCurrent(productId: number): boolean {
    let result = false;
    this.currentProductIds.forEach((currentProductId) => {
      if (currentProductId == productId) {
        result = true;
      }
    });
    return result;
  }

  getCurrentClass(productId: number): string {
    if (this.isProductInCurrent(productId)) {
      return "current";
    }
    return "";
  }
}
